import "./style.css";

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

type SlotName = "game" | "content";

const publisherId = import.meta.env.VITE_ADSENSE_PUBLISHER_ID?.trim() ?? "";
const slotIds: Record<SlotName, string> = {
  game: import.meta.env.VITE_ADSENSE_SLOT_GAME?.trim() ?? "",
  content: import.meta.env.VITE_ADSENSE_SLOT_CONTENT?.trim() ?? ""
};
const publisherIdPattern = /^ca-pub-\d{16}$/;
const adUnitPattern = /^\d+$/;
const adSlots = Array.from(document.querySelectorAll<HTMLElement>("[data-ad-slot]"));

if (adSlots.length > 0) {
  const hasValidPublisher = publisherIdPattern.test(publisherId);
  if (hasValidPublisher) {
    loadAdSense(publisherId);
  }

  adSlots.forEach((slot) => renderSlot(slot, hasValidPublisher));
}

function loadAdSense(client: string): void {
  if (
    document.querySelector("script[data-punch-panic-adsense]") ||
    document.querySelector('script[src*="pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]')
  ) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.crossOrigin = "anonymous";
  script.dataset.punchPanicAdsense = "true";
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(client)}`;
  document.head.append(script);
}

function renderSlot(slot: HTMLElement, hasValidPublisher: boolean): void {
  const slotName = slot.dataset.adSlot as SlotName | undefined;
  const adUnitId = slotName ? slotIds[slotName] : "";
  const hasAdUnit = adUnitPattern.test(adUnitId);

  slot.textContent = "";

  if (!hasValidPublisher || !hasAdUnit) {
    slot.classList.add("ad-placeholder");
    slot.innerHTML = "<span>Advertisement</span><small>Ad space reserved</small>";
    return;
  }

  slot.classList.remove("ad-placeholder");
  const ad = document.createElement("ins");
  ad.className = "adsbygoogle";
  ad.style.display = "block";
  ad.dataset.adClient = publisherId;
  ad.dataset.adSlot = adUnitId;
  ad.dataset.adFormat = "auto";
  ad.dataset.fullWidthResponsive = "true";
  slot.append(ad);

  window.adsbygoogle = window.adsbygoogle ?? [];
  window.adsbygoogle.push({});
}
